import { isInternetExplorer } from './client-browser';

const BOM_SYMBOL = '\ufeff';

const _download = (data, filename) => {
    // IE11 & Edge
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(data, filename);
    } else {
        // In FF link must be added to DOM to be clicked
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

export const downloadFile = (url, filename, uatraits) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    if (uatraits && isInternetExplorer(uatraits)) {
        link.setAttribute('target', '_blank');
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const downloadCSV = (csvString, filename, hasHeader = false) => {
    const csvData = new Blob([BOM_SYMBOL + csvString], {
        type: `text/csv;charset=utf-8;${hasHeader ? 'header=present;' : ''}`,
    });
    _download(csvData, filename);
};
